import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { formValues } from 'redux-form';

import { InputField } from 'components/form/field';
import { GridLayout } from 'components/form/layout';
import Operation from '../../../../simulation/types/scpi/Products/Operation';
import Funding from '../../../../simulation/types/scpi/Products/Funding';
import DismemberedOperation from '../../../../simulation/types/dismemberedScpi/Products/Operation';

const FinancialCIFFieldsInner = ({ currentValue, name, duration, needFunding }) => {
    switch (currentValue) {
        case 'LODEOMCIF':
            return (
                <GridLayout className="condensed full-width">
                    <div className="double">

                        <InputField name={`${name}.partenaire`} title="Partenaire" type="text" required />

                    </div>
                    {'LODEOMCIF' === currentValue && (
                        <Fragment>
                            <InputField name={`${name}.fatherLastName`} title="Nom du père" type="text" required />
                            <InputField name={`${name}.fatherFirstName`} title="Prénom du père" type="text" required />
                            <InputField
                                name={`${name}.motherBirthLastName`}
                                title="Nom de naissance de la mère"
                                type="text"
                                required
                            />
                            <InputField name={`${name}.motherFirstName`} title="Prénom de la mère" type="text" required />
                        </Fragment>
                    )}

                </GridLayout>
            );
        case 'SCPIRendement':
            return (
                <Operation showNeedFunding={false} namePrefix={`${name}`} required />
            );
        case 'SCPIaCredit':
            return (
                <Fragment>
                    <Operation namePrefix={`${name}`} needFunding={needFunding} disabledButtonNeedFunding required />
                    <Funding namePrefix={`${name}`} />
                </Fragment>
            );
        case 'SCPIDemembreeCIF':
            return (
                <Fragment>
                    <DismemberedOperation namePrefix={`${name}`} duration={duration} required />
                </Fragment>
            );
        default:
            return null;
    }
};

FinancialCIFFieldsInner.propTypes = {
    currentValue: PropTypes.string,
    name: PropTypes.string.isRequired,
    duration: PropTypes.number,
    needFunding: PropTypes.bool,
};

FinancialCIFFieldsInner.defaultProps = {
    currentValue: '',
    duration: 10,
    needFunding: true,
};

const FinancialFields = formValues(({ name }) => ({
    currentValue: `${name}.type`,
    duration: `${name}.duration`,
    needFunding: `${name}.needFunding`,
}))(FinancialCIFFieldsInner);

export default FinancialFields;
